module.exports = __webpack_public_path__ + "img/menu.de034c01.svg";